import styles from './index.less';
import * as React from 'react';
import cx from 'classnames';

/* QR 三态互斥键 → PSD 图层组（group-7/8/9 = 状态1/2/3）。
   显隐由 props 驱动，显示/隐藏路径双向显式（见 index.less 运行时显隐控制层）。 */
const QR_GROUP_NUMBERS = {
  team: 7,
  home: 8,
  download: 9
};

/* 门派海报素材表（2026-09-15 正式分门派资源，images/menpai-posters/{sect}/）：
   - bg-male / bg-female：海报主体底框+门派背景的合成图（556×988，与原底框同幅，取代原两层）；
   - 五张信息行标签图为未缩放原始尺寸（459×54），渲染按原 PSD 槽位尺寸等比缩放（236×27~28），
     DOM 与 Canvas 共用本表；
   - iconSourceSize：门派 icon 素材实测像素尺寸（2026-09-21 实测，五门派各不相同且多为非正方形，
     原「36×36」注释仅武当成立）——Canvas 绘制按其做 contain 等比缩放，替换素材须同步本表；
   - textColor：信息行实际拉取文字的门派主题色（DOM 内联与 Canvas fillStyle 同源）。
   资源目录 jinzong（少 h）与 sectKey 前缀 jinzhong 的拼写差异在此收敛。 */
const SECT_ASSETS = {
  tianwang: {
    backgroundImages: {
      male: require('./images/menpai-posters/tianwang/bg-male.png'),
      female: require('./images/menpai-posters/tianwang/bg-female.png')
    },
    labelImages: {
      tags: require('./images/menpai-posters/tianwang/tag_list.png'),
      menpaiName: require('./images/menpai-posters/tianwang/role_menpai_name.png'),
      registerDate: require('./images/menpai-posters/tianwang/register_date.png'),
      formerRoleName: require('./images/menpai-posters/tianwang/role_name.png'),
      score: require('./images/menpai-posters/tianwang/jianxia_score.png')
    },
    menpaiIcon: require('./images/menpai-posters/tianwang/menpai-icon.png'),
    iconSourceSize: { width: 44, height: 41 },
    textColor: '#262625'
  },
  qianji: {
    backgroundImages: {
      male: require('./images/menpai-posters/qianji/bg-male.png'),
      female: require('./images/menpai-posters/qianji/bg-female.png')
    },
    labelImages: {
      tags: require('./images/menpai-posters/qianji/tag_list.png'),
      menpaiName: require('./images/menpai-posters/qianji/role_menpai_name.png'),
      registerDate: require('./images/menpai-posters/qianji/register_date.png'),
      formerRoleName: require('./images/menpai-posters/qianji/role_name.png'),
      score: require('./images/menpai-posters/qianji/jianxia_score.png')
    },
    menpaiIcon: require('./images/menpai-posters/qianji/menpai-icon.png'),
    iconSourceSize: { width: 38, height: 39 },
    textColor: '#005649'
  },
  jinzhong: {
    backgroundImages: {
      male: require('./images/menpai-posters/jinzong/bg-male.png'),
      female: require('./images/menpai-posters/jinzong/bg-female.png')
    },
    labelImages: {
      tags: require('./images/menpai-posters/jinzong/tag_list.png'),
      menpaiName: require('./images/menpai-posters/jinzong/role_menpai_name.png'),
      registerDate: require('./images/menpai-posters/jinzong/register_date.png'),
      formerRoleName: require('./images/menpai-posters/jinzong/role_name.png'),
      score: require('./images/menpai-posters/jinzong/jianxia_score.png')
    },
    menpaiIcon: require('./images/menpai-posters/jinzong/menpai-icon.png'),
    iconSourceSize: { width: 27, height: 44 },
    textColor: '#560e00'
  },
  yishui: {
    backgroundImages: {
      male: require('./images/menpai-posters/yishui/bg-male.png'),
      female: require('./images/menpai-posters/yishui/bg-female.png')
    },
    labelImages: {
      tags: require('./images/menpai-posters/yishui/tag_list.png'),
      menpaiName: require('./images/menpai-posters/yishui/role_menpai_name.png'),
      registerDate: require('./images/menpai-posters/yishui/register_date.png'),
      formerRoleName: require('./images/menpai-posters/yishui/role_name.png'),
      score: require('./images/menpai-posters/yishui/jianxia_score.png')
    },
    menpaiIcon: require('./images/menpai-posters/yishui/menpai-icon.png'),
    iconSourceSize: { width: 45, height: 36 },
    textColor: '#234979'
  },
  wudang: {
    backgroundImages: {
      male: require('./images/menpai-posters/wudang/bg-male.png'),
      female: require('./images/menpai-posters/wudang/bg-female.png')
    },
    labelImages: {
      tags: require('./images/menpai-posters/wudang/tag_list.png'),
      menpaiName: require('./images/menpai-posters/wudang/role_menpai_name.png'),
      registerDate: require('./images/menpai-posters/wudang/register_date.png'),
      formerRoleName: require('./images/menpai-posters/wudang/role_name.png'),
      score: require('./images/menpai-posters/wudang/jianxia_score.png')
    },
    menpaiIcon: require('./images/menpai-posters/wudang/menpai-icon.png'),
    iconSourceSize: { width: 36, height: 36 },
    textColor: '#004556'
  }
};

/** 非法 sectKey 的回退键（PSD 默认可见的门派1 基线）。 */
const DEFAULT_SECT_KEY = 'tianwang-male';

/**
 * 按门派+性别解析门派素材（合成背景 / 标签图组 / 门派 icon / 文字主题色）；非法键回退门派1 基线。
 *
 * @param {string} sectKey 5×2 门派性别映射键。
 * @returns {{background:string, labelImages:Object, menpaiIcon:string, textColor:string}} 门派素材集。
 */
function resolveSectAssets(sectKey) {
  const sectPrefix = String(sectKey || '').split('-')[0];
  const gender = String(sectKey || '').split('-')[1];
  const assets = SECT_ASSETS[sectPrefix] || SECT_ASSETS[DEFAULT_SECT_KEY.split('-')[0]];
  return {
    background: gender === 'female' ? assets.backgroundImages.female : assets.backgroundImages.male,
    labelImages: assets.labelImages,
    menpaiIcon: assets.menpaiIcon,
    iconSourceSize: assets.iconSourceSize,
    textColor: assets.textColor
  };
}

/* 展示 ViewModel 默认值取 PSD 占位文本：未受控渲染时与 psd-to-html 基线一致，便于 POSTER-MANUAL-007 人工比对。 */
const DEFAULT_VIEW_MODEL = {
  tagsText: '江湖旧友 / 社交达人 / PvP达人',
  menpaiName: '易水',
  registerDateText: '2023年7月19日',
  formerRoleNameText: '清风明月',
  jianxiaScoreText: '8999分'
};

/* 「保存海报」CanvasImagePainter 参数（布局知识归静态壳模块，副作用编排归页面 Store——findings Owner 映射）。
   画布截取范围为 PSD 海报主体（group5，556×988）：名帖本体（合成背景、身份信息、当前二维码），
   不含底部按钮与奖励文案等页面级交互元素；各成员坐标由 index.less 绝对定位逐层换算。 */
export const POSTER_CANVAS_SIZE = { width: 556, height: 988 };

/* 二维码说明文案图（PSD 共享图，非门派维度资源）按 qrMode 三态取用：
   2026-09-24 修正——原「三态文案图字节一致，固定取 layer-10」的判断不成立
   （实测 layer-10 与 layer-12/14 的 md5/体积均不同），home/download 模式保存图内
   出现「扫码加入队伍」文案配主页/下载码的内容矛盾（缺陷案例：无 invite_params 账号保存图） */
const QR_CAPTION_IMAGES = {
  team: require('./images/mo-poster-layer-10.png'),
  home: require('./images/mo-poster-layer-12.png'),
  download: require('./images/mo-poster-layer-14.png')
};

/* 身份信息文本公共字体声明（颜色按门派主题动态化，见 resolveSectAssets）；
   字重与字号按行对齐 index.less 文本层（layer17/18/22/24/26）的 bold + 设计稿字号 */
const POSTER_TEXT_FONT_FAMILY = 'FZSHENGSKS_DAJW--GB1-0 AdobeInvisFont AdobeHeitiStd-Regular';
const POSTER_TEXT_FONT_WEIGHT = 'bold';
/* 各行文本字号（2026-09-21 修正：原 19.07px 为 PSD 源字号未按 750 设计稿换算，生成图文字偏小——
   恢复与 DOM 预览一致的设计稿字号：江湖标签行 22px，其余四行 24px） */
const INFO_TEXT_FONT_SIZES = {
  score: '24px',
  formerRoleName: '24px',
  registerDate: '24px',
  menpaiName: '24px',
  tags: '22px'
};

/* 具体信息块（group12）画布内原点：group5(0,0) → group12(28,455)，画布层换算 +8（原 group10 偏移随合成图取消）；
   五行信息 top 依次为 剑侠评分 0 / 曾用名 80 / 注册时间 160 / 门派名称 241 / 江湖标签 320（group17~group13） */
const INFO_BLOCK_ORIGIN = { x: 36, y: 478 };
const INFO_ROW_TOPS = { score: 0, formerRoleName: 80, registerDate: 160, menpaiName: 241, tags: 320 };
/* 各行文本层相对行首的 (x, y) 偏移：与 index.less 文本层（layer26/24/22/18/17）的 left/top 保持同源——
   2026-09-08 字体 webfont 化后浏览器/canvas 渲染基线整体偏上，五处 top 统一 +6 对齐视觉基准（勿回退 PSD 原值） */
const INFO_TEXT_OFFSETS = {
  score: { x: 8, y: 38.23 },
  formerRoleName: { x: 9, y: 37.23 },
  registerDate: { x: 8, y: 38.23 },
  menpaiName: { x: 36, y: 36.23 },
  tags: { x: 8, y: 37.23 }
};
/* 各行标签图绘制尺寸（原 PSD 槽位；新素材为 459×54 未缩放图，等比缩放 ~0.514 绘入） */
const INFO_LABEL_SIZES = {
  score: { width: 236, height: 27 },
  formerRoleName: { width: 236, height: 28 },
  registerDate: { width: 236, height: 28 },
  menpaiName: { width: 236, height: 28 },
  tags: { width: 236, height: 27 }
};
/* 门派 icon 槽位（group14 内 (3,35)，原 PSD 33×30）：Canvas 绘制按各门派素材实测尺寸
   （SECT_ASSETS.iconSourceSize）做 contain 等比缩放并在槽位双向居中——与 DOM background-size: contain 同口径；
   五门派素材尺寸各不相同且多为非正方形（2026-09-21 实测），禁止写死绘制尺寸导致拉伸变形 */
const MENPAI_ICON_SLOT = { offsetX: 3, offsetY: 35, width: 33, height: 30 };

/**
 * 计算门派 icon 在 33×30 槽位内的 contain 等比绘制区域（DOM background-size: contain 同口径）。
 *
 * @param {{width:number, height:number}} iconSourceSize 素材实测像素尺寸。
 * @returns {{x:number, y:number, width:number, height:number}} 相对门派名称行首的绘制区域。
 */
function resolveMenpaiIconDrawRect(iconSourceSize) {
  const scale = Math.min(MENPAI_ICON_SLOT.width / iconSourceSize.width, MENPAI_ICON_SLOT.height / iconSourceSize.height);
  const width = iconSourceSize.width * scale;
  const height = iconSourceSize.height * scale;
  return {
    x: MENPAI_ICON_SLOT.offsetX + (MENPAI_ICON_SLOT.width - width) / 2,
    y: MENPAI_ICON_SLOT.offsetY + (MENPAI_ICON_SLOT.height - height) / 2,
    width,
    height
  };
}

/* 二维码区（group6）画布内定位：QR 槽位 (16,902) 74×74，说明文案 (106,916) 186×47
   （2026-09-28 修正：三张文案素材像素不一——layer-10 为 186×47 原尺寸、layer-12/14 为 361×92
   的 2x 导出图，canvas 不传宽高会按素材原始像素绘出近一倍大小，须显式钉住槽位尺寸） */
const QR_MEMBER_POSITION = { x: 16, y: 902 };
const QR_MEMBER_SIZE = 74;
const QR_CAPTION_POSITION = { x: 106, y: 916 };
/** 说明文案槽位尺寸（DOM layer10/12/14 同槽 186×47）：素材像素不一致，绘制统一钉住槽位尺寸 */
const QR_CAPTION_SIZE = { width: 186, height: 47 };

/**
 * 组织「保存海报」的 CanvasImagePainter 绘制成员：门派合成背景 → 身份信息（门派标签图 + 门派主题色文本）
 * → 二维码说明文案（按 qrMode 三态取图）→ 当前二维码。
 * 身份文本取页面 ViewModel（空值已由 Store 兜底为 '--'）；老玩家行（曾用名/评分）沿用视图同一约定：
 * viewModel 未传或携带 formerRoleNameText 键时绘制，否则跳过（新玩家）。
 *
 * @param {object} params
 * @param {string} params.sectKey 5×2 门派性别映射键（决定门派背景/标签图/icon/文字色资源）。
 * @param {object} [params.viewModel] 页面 Store 的 posterViewModel（文本字段已格式化）。
 * @param {string} params.qrTarget 当前二维码目标 URL（team/home/download 三态共用）。
 * @param {string} [params.qrMode] 当前二维码互斥态（team/home/download，默认 team），
 *   决定说明文案图取用（QR_CAPTION_IMAGES），须与页面 qrMode 同源传入。
 * @returns {Array<object>} CanvasImagePainter members。
 */
export function createPosterMembers({ sectKey, viewModel, qrTarget, qrMode = 'team' } = {}) {
  const sectAssets = resolveSectAssets(sectKey);
  const veteranFieldsVisible = !viewModel || Object.prototype.hasOwnProperty.call(viewModel, 'formerRoleNameText');
  const display = viewModel || {};
  /* CanvasText 的非旋转绘制路径不设置 ctx.textBaseline（@xfe-team/canvas-image-painter 库缺陷）：
     member 传入的 textBaseline 被忽略，ctx 恒为默认 alphabetic 基线，文字整体上移约一个 ascent（~15px）。
     经 onDraw 自定义绘制以 top 基线落位，y 语义与 index.less 文本层的 top 同源（2026-09-08 基线含 +6 视觉修正）；
     fillColor 随门派主题色变化（2026-09-15 需求）。 */
  const createTextMember = (text, x, y, fontSize) => ({
    type: 'text',
    text,
    x,
    y,
    onDraw: ctx => {
      ctx.fillStyle = sectAssets.textColor;
      ctx.font = `${POSTER_TEXT_FONT_WEIGHT} ${fontSize} ${POSTER_TEXT_FONT_FAMILY}`;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillText(text, x, y);
    }
  });
  const createInfoRow = (rowKey, text) => {
    const rowY = INFO_BLOCK_ORIGIN.y + INFO_ROW_TOPS[rowKey];
    const labelSize = INFO_LABEL_SIZES[rowKey];
    const members = [{ type: 'img', src: sectAssets.labelImages[rowKey], x: INFO_BLOCK_ORIGIN.x, y: rowY, width: labelSize.width, height: labelSize.height }];
    const textOffset = INFO_TEXT_OFFSETS[rowKey];
    members.push(createTextMember(text, INFO_BLOCK_ORIGIN.x + textOffset.x, rowY + textOffset.y, INFO_TEXT_FONT_SIZES[rowKey]));
    return members;
  };

  const members = [
    /* 合成背景（底框+门派海报已合一，556×988 与原底框同幅）：原「底框 (0,0) + 门派背景 (8,23)」两层由此取代 */
    { type: 'img', src: sectAssets.background, x: 0, y: 0, width: POSTER_CANVAS_SIZE.width, height: POSTER_CANVAS_SIZE.height },
    {
      type: 'img',
      src: QR_CAPTION_IMAGES[qrMode] || QR_CAPTION_IMAGES.team,
      x: QR_CAPTION_POSITION.x,
      y: QR_CAPTION_POSITION.y,
      width: QR_CAPTION_SIZE.width,
      height: QR_CAPTION_SIZE.height
    }
  ];

  if (veteranFieldsVisible) {
    members.push(...createInfoRow('score', display.jianxiaScoreText));
    members.push(...createInfoRow('formerRoleName', display.formerRoleNameText));
  }

  members.push(...createInfoRow('registerDate', display.registerDateText));
  members.push(...createInfoRow('menpaiName', display.menpaiName));
  // 门派 icon 独立于文本层（group14 内槽位 (3,35)）：按各门派素材实测尺寸 contain 等比缩放并双向居中（对齐 DOM）
  const iconRect = resolveMenpaiIconDrawRect(sectAssets.iconSourceSize);
  members.push({
    type: 'img',
    src: sectAssets.menpaiIcon,
    x: INFO_BLOCK_ORIGIN.x + iconRect.x,
    y: INFO_BLOCK_ORIGIN.y + INFO_ROW_TOPS.menpaiName + iconRect.y,
    width: iconRect.width,
    height: iconRect.height
  });
  members.push(...createInfoRow('tags', display.tagsText));
  // correctLevel 对齐页面预览（qrcode.react 默认 L）：否则 qrious 默认 M 会在边界长度选择更高版本（如短链 L=v2 / M=v3），
  // 同一内容画出不同矩阵——保存图与预览的二维码图案不一致；静区保留 qrious 自动居中（比 4 模块更宽，利于扫码）
  members.push({ type: 'qr', text: qrTarget, x: QR_MEMBER_POSITION.x, y: QR_MEMBER_POSITION.y, size: QR_MEMBER_SIZE, correctLevel: 'L' });

  return members;
}

const MoPoster = ({
  className,
  qrMode = 'team',
  sectKey = 'tianwang-male',
  viewModel,
  actionsDisabled = false,
  qrCodeNode,
  onOpenTagEditor,
  onOpenRoleEditor,
  onSavePoster,
  // 底部左按钮（layer-2）：2026-09-20 需求调整——原「生成邀请链接」复制入口移入分享海报弹窗底部，
  // 本按钮语义改为「前往组队页」（图素已同步替换，槽位几何不变）
  onGoTeam,
  // PSD 无对应节点：右上角临时关闭入口由页面层按 findings 授权新增后（spec Task 5）接入该回调。
  onClosePage
}) => {
  const display = { ...DEFAULT_VIEW_MODEL, ...viewModel };
  const getVisibilityClassName = isVisible => (isVisible ? styles.visibleStateLayer : styles.hiddenStateLayer);
  const activeQrGroupNumber = QR_GROUP_NUMBERS[qrMode] || QR_GROUP_NUMBERS.team;
  /* 门派素材（合成背景 / 标签图组 / icon / 文字主题色）按「门派-性别」动态解析；
     背景为底框+门派背景的合成图，仅渲染当前键的一层，DOM 不再全量渲染五个互斥门派组 */
  const sectAssets = resolveSectAssets(sectKey);
  /* 标签图槽位尺寸固定（原 PSD 槽位），未缩放新素材经 background-size:cover 等比缩入 */
  const labelBackground = image => ({ backgroundImage: `url(${image})` });
  /* 新老玩家身份字段显隐（受控 view contract）：受控 viewModel 不含 formerRoleNameText 键
     （页面 Store 对新玩家不输出该键）时隐藏 曾用名/剑侠评分 两组信息行；
     viewModel 未传（未受控）时保持 PSD 占位基线（POSTER-MANUAL-007 比对基准）。 */
  const veteranFieldsVisible = !viewModel || Object.prototype.hasOwnProperty.call(viewModel, 'formerRoleNameText');
  const veteranFieldsVisibilityClassName = getVisibilityClassName(veteranFieldsVisible);

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.layer1} data-name="海报生成页-背景" />
      <div className={styles.group1} data-name="海报生成页-主体">
        <div className={styles.group2} data-name="底部按钮区">
          {/* 2026-09-20 需求：左按钮由「生成邀请链接」（复制）改为「前往组队页」；
              data-name 保留 PSD 槽位锚点（几何未变，保住视觉回归基线），图素已替换 */}
          <button
            className={cx(styles.layer2, styles.hitArea)}
            data-name="链接按钮"
            type="button"
            aria-label="前往组队页"
            disabled={actionsDisabled}
            onClick={onGoTeam}
          />
          <button
            className={cx(styles.layer3, styles.hitArea)}
            data-name="海报按钮"
            type="button"
            aria-label="保存海报"
            disabled={actionsDisabled}
            onClick={onSavePoster}
          />
        </div>

        <div
          className={styles.layer4}
          data-name="保存名帖或复制链接分享，将获得外观奖励！ 奖励请跳转到“我的背包”查收"
          data-text="保存名帖或复制链接分享，将获得外观奖励！奖励请跳转到“我的背包”查收"
        >
          保存名帖或复制链接分享，将获得外观奖励！&#10;奖励请跳转到“我的背包”查收
        </div>
        <div className={styles.group3} data-name="海报生成区">
          <div className={styles.layer5} data-name="海报生成区-背景" />
          <div className={styles.group4} data-name="海报内容变更按钮">
            <button
              className={cx(styles.layer6, styles.hitArea)}
              data-name="按钮: 更换标签"
              type="button"
              aria-label="更换标签"
              disabled={actionsDisabled}
              onClick={onOpenTagEditor}
            />
            <button
              className={cx(styles.layer7, styles.hitArea)}
              data-name="按钮: 更换门派"
              type="button"
              aria-label="更换门派"
              disabled={actionsDisabled}
              onClick={onOpenRoleEditor}
            />
          </div>

          <div className={styles.group5} data-name="海报主体">
            {/* 门派海报合成背景单层（底框+门派背景已合一，556×988 与原底框同幅）：
                按 sectKey（门派+性别）取 10 态资源，替代原「底框 + 门派背景」两层 */}
            <div className={styles.sectBackgroundLayer} data-name="门派海报背景" style={{ backgroundImage: `url(${sectAssets.background})` }} />
            <div className={styles.group6} data-name="二维码">
              <div className={cx(styles.group7, getVisibilityClassName(activeQrGroupNumber === 7))} data-name="状态1：队伍邀请二维码">
                <div className={styles.layer9} data-name="队伍邀请二维码" />
                <div className={styles.layer10} data-name="文案1" />
              </div>

              <div className={cx(styles.group8, getVisibilityClassName(activeQrGroupNumber === 8))} data-name="状态2：活动首页二维码">
                <div className={styles.layer11} data-name="活动首页二维码" />
                <div className={styles.layer12} data-name="文案2" />
              </div>

              <div className={cx(styles.group9, getVisibilityClassName(activeQrGroupNumber === 9))} data-name="状态3：游戏下载二维码">
                <div className={styles.layer13} data-name="游戏下载二维码" />
                <div className={styles.layer14} data-name="文案3" />
              </div>

              {/* QR 实例挂载槽（受控 view contract：视图挂载位）：三态组坐标一致（0,0），
                  真实二维码叠加渲染于 PSD 三态占位图之上；仅当调用方传入 qrCodeNode（数据就绪）时渲染，
                  未传时保持 PSD 占位基线。 */}
              {qrCodeNode ? <div className={styles.qrCodeSlot}>{qrCodeNode}</div> : null}
            </div>

            {/* 身份信息块单份（group12~17 结构模板）：标签图/门派 icon/文字主题色按门派动态化
                （2026-09-15 正式分门派资源），槽位几何沿用原 PSD 基线 */}
            <div className={styles.group12} data-name="具体信息">
              <div className={styles.group13} data-name="玩家信息 - 江湖标签">
                <div className={styles.layer16} data-name="玩家信息 - 江湖标签标签" style={labelBackground(sectAssets.labelImages.tags)} />
                <div className={styles.layer17} data-name="接口拉取江湖标签" data-text={display.tagsText} style={{ color: sectAssets.textColor }}>
                  {display.tagsText}
                </div>
              </div>

              <div className={styles.group14} data-name="玩家信息 - 门派名称">
                <div className={styles.layer18} data-name="接口拉取门派名称" data-text={display.menpaiName} style={{ color: sectAssets.textColor }}>
                  {display.menpaiName}
                </div>
                <div className={styles.layer19} data-name="门派icon - 1" style={labelBackground(sectAssets.menpaiIcon)} />
                <div className={styles.layer20} data-name="玩家信息 - 门派名称标签" style={labelBackground(sectAssets.labelImages.menpaiName)} />
              </div>

              <div className={styles.group15} data-name="玩家信息 - 注册时间">
                <div className={styles.layer21} data-name="玩家信息 - 注册时间标签" style={labelBackground(sectAssets.labelImages.registerDate)} />
                <div className={styles.layer22} data-name="接口拉取注册时间" data-text={display.registerDateText} style={{ color: sectAssets.textColor }}>
                  {display.registerDateText}
                </div>
              </div>

              <div className={cx(styles.group16, veteranFieldsVisibilityClassName)} data-name="玩家信息 - 曾用名">
                <div className={styles.layer23} data-name="玩家信息 - 曾用名标签" style={labelBackground(sectAssets.labelImages.formerRoleName)} />
                <div className={styles.layer24} data-name="接口拉取名称" data-text={display.formerRoleNameText} style={{ color: sectAssets.textColor }}>
                  {display.formerRoleNameText}
                </div>
              </div>

              <div className={cx(styles.group17, veteranFieldsVisibilityClassName)} data-name="玩家信息 - 剑侠评分">
                <div className={styles.layer25} data-name="玩家信息 - 剑侠评分标签" style={labelBackground(sectAssets.labelImages.score)} />
                <div className={styles.layer26} data-name="接口拉取评分" data-text={display.jianxiaScoreText} style={{ color: sectAssets.textColor }}>
                  {display.jianxiaScoreText}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.layer75} data-name="海报生成页 - 标题" />
    </div>
  );
};

export default MoPoster;
